import React from 'react';
import { Scenario, Activity } from '@bingads-webui-react/hoc-with-signal';

export const withActivity = WrappedComponent => React.memo(props => (
  <Scenario name="pmax-lite">
    <Activity name="ad-assets-step" >
      <WrappedComponent {...props} />
    </Activity>
  </Scenario>
));
